export default "__VITE_ASSET__4c41ab28__"